import type { ThemeClasses } from "../types";

interface ModelHeaderProps {
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  selectedView: "grid" | "list";
  setSelectedView: (view: "grid" | "list") => void;
  onAddModel: () => void;
  t: (key: string, options?: any) => string;
}

export function ModelHeader({
  themeClasses,
  isDarkMode,
  searchQuery,
  onSearchChange,
  selectedView,
  setSelectedView,
  onAddModel,
  t,
}: ModelHeaderProps) {
  return (
    <div
      className={`${themeClasses.bg} border-b ${themeClasses.border} p-4 lg:p-6`}
    >
      {/* Title */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4">
        <div>
          <h1 className={`text-xl lg:text-2xl font-bold ${themeClasses.text}`}>
            {t("models.title")}
          </h1>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
            {t("models.subtitle")}
          </p>
        </div>
        <button
          onClick={onAddModel}
          className="mt-4 lg:mt-0 px-4 py-2 bg-primary-500 hover:bg-primary-400 text-gray-900 rounded-lg font-medium transition-colors flex items-center justify-center"
        >
          <i className="ri-add-line mr-2"></i>
          {t("models.addModel")}
        </button>
      </div>

      {/* Filters */}
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        {/* Search */}
        <div className="relative flex-1">
          <i
            className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 ${themeClasses.textSecondary}`}
          ></i>
          <input
            type="text"
            placeholder={t("models.searchPlaceholder")}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className={`w-full pl-10 pr-4 py-2 ${isDarkMode ? "bg-dark-card" : "bg-white"} border ${themeClasses.cardBorder} rounded-lg ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-primary-500`}
          />
        </div>

        {/* View toggle */}
        <div className="flex items-center space-x-2">
          <button
            onClick={() => setSelectedView("grid")}
            className={`p-2 rounded-lg transition-colors ${
              selectedView === "grid"
                ? "bg-primary-500 text-gray-900"
                : `${themeClasses.buttonHover} ${themeClasses.buttonText}`
            }`}
          >
            <i className="ri-grid-fill"></i>
          </button>
          <button
            onClick={() => setSelectedView("list")}
            className={`p-2 rounded-lg transition-colors ${
              selectedView === "list"
                ? "bg-primary-500 text-gray-900"
                : `${themeClasses.buttonHover} ${themeClasses.buttonText}`
            }`}
          >
            <i className="ri-list-check"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
